import "Enum.js";

/** @namespace GIS */
NS("GIS");

/**
 * @class
 * @extends Enum
 * @enum
 */
GIS.LayerType = Static(Enum, /** @lends GIS.LayerType */ {
    Vector: 1,
    Raster: 2
});
